export const flattenArray = (arr, attr = 'children') => {
  return arr ? arr.reduce((result, item) => [...result, item, ...flattenArray(item[attr])], []) : [];
};
